import { Prop, Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class NotificationMessage extends ThemeComponent {

    @Prop() timed!: boolean;

    init() {
        if (this.timed) {
            this.setRemoval();
        }
    }

    setRemoval() {
        setTimeout(() => {
            this.remove();
        }, 4000);
    }

}
